import ApiService from "@/common/api.service";

export const TraineeFacilitiesService = {
    create(params) {
        return ApiService.post("traineeFacilities/add", params);
    },
    update(slug, params) {
        return ApiService.update("traineeFacilities", slug, params);
    },
    async getLocationByType(locationType, locationId) {
        let location = await ApiService.get("location/" + locationType + "/" + locationId);
        return location.data ? location.data.data : []
    },
    async getTraineeFacilityByType(locationType, locationId) {
        let location = await ApiService.get("traineeFacilities/" + locationType + "/" + locationId);
        return location.data ? location.data.data : []
    },
    async getRegions() {
        return ApiService.get("/location");
    },

};
